//#region imports
import { NgForm } from '@angular/forms';
import { MatDialogRef, MatDialog } from '@angular/material';
import { SaveService } from 'src/app/services/save.service';
import { ContactDetails } from './../../../model/save.model';
import { Component, OnInit } from '@angular/core';
import { RecallConfirmationDialogComponent } from '../recall-confirmation-dialog/recall-confirmation-dialog.component';
import { CharacteristicService } from 'src/app/services/characteristic.service';
import { P5xService } from 'src/app/services/p5x.service';
import { DocumentService } from 'src/app/services/document.service';
import { SignatureService } from 'src/app/services/signature.service';
import { AppConstants } from 'src/app/app.constants';
import { Globals } from 'src/app/services/globals';
//#endregion

@Component({
  selector: 'app-recall-dialog',
  templateUrl: './recall-dialog.component.html',
  styleUrls: ['./recall-dialog.component.css']
})
export class RecallDialogComponent implements OnInit {
  //#region variables
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  code: string;
  dob: string;
  street: string;
  streetno:string;
  boxno: string;
  contactDetails: ContactDetails;
  simulationOptionChk = false;
  clientIdOrSimulationTokenPresent: boolean;
  emailpattern: any;
  //#endregion

  //#region methods
  constructor(
    private matDialog: MatDialog, private dialogRef: MatDialogRef<RecallDialogComponent>,
    private characteristicService: CharacteristicService, private saveService: SaveService,
    private p5xService: P5xService, private documentService: DocumentService, private signatureService: SignatureService,
    private globals: Globals) { 
      dialogRef.disableClose = false;
    }

  ngOnInit() {
    this.clientIdOrSimulationTokenPresent = this.characteristicService.getClientIdOrSimulationTokenPresent();
    this.contactDetails = this.saveService.getContactDetails();
    if (this.contactDetails) {
      this.firstName = this.contactDetails.FirstName;
      this.lastName = this.contactDetails.LastName;
      this.email = this.contactDetails.EmailAddress;
      this.phone = this.contactDetails.Telephone;
      this.code = this.contactDetails.PostalCode;
      this.dob = this.contactDetails.DateofBirth;
      this.street = this.contactDetails.StreetName;
      this.streetno = this.contactDetails.StreetNumber;
      this.boxno = this.contactDetails.BoxNumber;
    }
    this.emailpattern = AppConstants.EmailIdRegexPattern;
  }

  onSubmit(myForm: NgForm) {
    let recallRequest;
    let recallConfirmationDetails;
    if (myForm.valid) {
      this.globals.trackPageActivity += ';' + 'RECALL';
      recallRequest = this.getRecallRequest(myForm);
      this.globals.sendSimulationMail = false;
      this.globals.generateSimulation = false;
      this.saveService.saveSimulation(recallRequest, 'ReserveRecall').subscribe((data) => {
        const simulationReservationReason = this.p5xService.getSimulationReservationReason();
        const documentgeneratestatus = this.p5xService.getDocumentGenerateStatus();
        if ((simulationReservationReason.ID === 3 || simulationReservationReason.ID === 4 ||
          simulationReservationReason.ID === 10) && !documentgeneratestatus) {
          this.setContactDetails(recallRequest);
          this.saveService.setSimulationToken(data.Tocken);
          this.saveService.setProspectNumber(data.CRMProspect);
          this.saveService.setShortToken(data.shortTocken);
          recallConfirmationDetails = this.getRecallConfirmationDetails(recallRequest, data.Tocken);
          if (this.signatureService.getSaveAddress1() !== undefined && this.signatureService.getSaveAddress1() !== null)
            {
              this.p5xService.setDisableP5XPrevious(true);
              this.documentService.callDocumentumFromP5XServiceRecall(null, null, null, this.dialogRef, recallConfirmationDetails);
            }
          else
          {
            this.dialogRef.close(true);
            this.matDialog.open(RecallConfirmationDialogComponent, { data: recallConfirmationDetails });
          }
        } else {
          this.dialogRef.close(true);
          this.setContactDetails(recallRequest);
          this.saveService.setSimulationToken(data.Tocken);
          this.saveService.setProspectNumber(data.CRMProspect);
        this.saveService.setShortToken(data.shortTocken);
          recallConfirmationDetails = this.getRecallConfirmationDetails(recallRequest, data.Tocken);
          this.matDialog.open(RecallConfirmationDialogComponent, { data: recallConfirmationDetails });
        }
        // console.log('test');
      });
      // console.log('valid form');
    } else {
      // console.log('invalid form');
    }
  }

  getRecallRequest(myForm) {
    if (this.clientIdOrSimulationTokenPresent) {
      return {
        firstName: this.firstName, lastName: this.lastName, email: myForm.value.email,
        phone: myForm.value.phone, code: myForm.value.code, optionSalesContact: myForm.value.simulationOptionChk
      };
    } else {
      return myForm.value;
    }
  }

  getRecallConfirmationDetails(recallRequest, tocken) {
    return {
      firstName: recallRequest.firstName + ' ' + recallRequest.lastName,
      email: recallRequest.email,
      phone: recallRequest.phone,
      code: recallRequest.code,
      Token: tocken
    };
  }

  setContactDetails(recallRequest) {
    const contactData: ContactDetails = {
      FirstName: recallRequest.firstName,
      Name: '',
      LastName: recallRequest.lastName,
      EmailAddress: recallRequest.email,
      Telephone: recallRequest.phone,
      PostalCode: recallRequest.code,
      DateofBirth: this.dob,
      StreetName: this.street,
      StreetNumber: this.streetno,
      BoxNumber:this.boxno
    };
    this.saveService.setContactDetails(contactData);
  }

  onClose() {
    this.dialogRef.close(true);
  }

  isNumber(evt, code) {
    if (code === 0) {
      evt = (evt) ? evt : window.event;
      evt.preventDefault();
    } else {
      evt = (evt) ? evt : window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((code.length > 14) || (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode != 43))) {
        evt.preventDefault();
      } else if (charCode == 107) {
        return true;
      } else {
        return true;
      }
    }
  }
  //#endregion
}
